var _circle, _circle2, _circle3, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconQuestion = function SvgIconQuestion(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 250 142"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 242.7,
    cy: 30.7,
    r: 5.8,
    fill: "#fff",
    stroke: "#bcc0c4",
    strokeWidth: 1.4
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 125.4,
    cy: 71.1,
    r: 70.5,
    fill: "#ebebeb"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 6.3,
    cy: 130.2,
    r: 5.8,
    fill: "#fff",
    stroke: "#ebebeb"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ebebeb",
    d: "M44.5 124.9h5v14.8h-5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ebebeb",
    d: "M39.5 129.9h15v4.9h-15z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#bcc0c4",
    d: "M20.2 82.6h6.4v19.1h-6.4z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#bcc0c4",
    d: "M13.8 88.9H33v6.4H13.8z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#ebebeb",
    d: "M28.1 42.4h3.6V53h-3.6z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#ebebeb",
    d: "M24.5 45.9h10.7v3.5H24.5zM206.2 4.2h6.4v19.1h-6.4z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#ebebeb",
    d: "M199.8 10.6H219V17h-19.2z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#bcc0c4",
    d: "M229 52.9h3.6v10.6H229z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#bcc0c4",
    d: "M225.5 56.5h10.7V60h-10.7z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#ebebeb",
    d: "M221.9 91.1h5v14.8h-5z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#ebebeb",
    d: "M216.9 96h15v4.9h-15z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#ec3a32",
    stroke: "#291000",
    d: "M118 89.2c0-5.3.6-9.5 1.9-12.6s3.6-6.2 7-9.2 5.7-5.5 6.8-7.4 1.7-3.9 1.7-6c0-6.4-2.9-9.5-8.8-9.5-2.8 0-5 .9-6.7 2.6s-2.5 4.1-2.6 7.1H101c.1-7.2 2.4-12.8 7-16.9s10.8-6.1 18.7-6.1c8 0 14.1 1.9 18.5 5.8s6.6 9.3 6.6 16.3c0 3.2-.7 6.2-2.1 9.1-1.4 2.8-3.9 6-7.5 9.4l-4.6 4.3c-2.9 2.7-4.5 6-4.9 9.6l-.2 3.4H118zm-1.6 17.3c0-2.5.9-4.6 2.6-6.2q2.55-2.4 6.6-2.4t6.6 2.4c1.7 1.6 2.6 3.7 2.6 6.2s-.8 4.5-2.5 6.1q-2.55 2.4-6.6 2.4c-2.7 0-5-.8-6.6-2.4-1.9-1.6-2.7-3.6-2.7-6.1z",
    strokeWidth: 1.4
  })));
};
export default SvgIconQuestion;